import { render, staticRenderFns } from "./BasketResume.vue?vue&type=template&id=05bb8ce1&"
import script from "./BasketResume.vue?vue&type=script&lang=js&"
export * from "./BasketResume.vue?vue&type=script&lang=js&"
import style0 from "./BasketResume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports